import { CREDIT_CARD_CODES } from '../../../modules/utils/constants/constants';

export type WalletSavedCardFeaturedDynamicImage = {
  damPath?: string;
  assetPath?: string;
  altText?: string;
  dynamic?: boolean;
};

export type WalletSavedCardImage = {
  image?: string;
  creditCardCode?: string;
  imageAltText?: string;
  featuredDynamicImage?: WalletSavedCardFeaturedDynamicImage;
};

export type ResolvedSavedCardArt = {
  src: string;
  altText?: string;
};

export const WALLET_SAVED_CARD_DEFAULT_CODE = 'default';

const DISPLAY_TO_INTERNAL_CODE = Object.fromEntries(
  Object.entries(CREDIT_CARD_CODES).map(([internalCode, displayCode]) => [displayCode, internalCode])
);

/** Normalize UXL issuer codes (V, M, A) and legacy display codes (VS, MC, AX) to AEM creditCardCode keys. */
export const normalizeSavedCardTypeCode = (cardTypeCode?: string): string => {
  const normalized = cardTypeCode?.trim() ?? '';
  if (!normalized) {
    return '';
  }

  if (DISPLAY_TO_INTERNAL_CODE[normalized]) {
    return DISPLAY_TO_INTERNAL_CODE[normalized];
  }

  return normalized;
};

export const resolveSavedCardArt = (
  cardTypeCode: string | undefined,
  cardImages?: WalletSavedCardImage[]
): ResolvedSavedCardArt | undefined => {
  if (!cardImages?.length) {
    return undefined;
  }

  const normalizedCode = normalizeSavedCardTypeCode(cardTypeCode);
  const matchedEntry =
    (normalizedCode ? cardImages.find(entry => entry.creditCardCode === normalizedCode) : undefined) ??
    cardImages.find(entry => entry.creditCardCode === WALLET_SAVED_CARD_DEFAULT_CODE);

  if (!matchedEntry) {
    return undefined;
  }

  const src = matchedEntry.featuredDynamicImage?.assetPath || matchedEntry.image;
  if (!src) {
    return undefined;
  }

  return {
    src,
    altText: matchedEntry.featuredDynamicImage?.altText || matchedEntry.imageAltText,
  };
};
